// Lightweight CSV utilities (no external dep). RFC4180-ish.

export function parseCsv(text) {
  const rows = [];
  let cur = [];
  let field = "";
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else field += ch;
    } else {
      if (ch === '"') inQuotes = true;
      else if (ch === ",") {
        cur.push(field);
        field = "";
      } else if (ch === "\n") {
        cur.push(field);
        rows.push(cur);
        cur = [];
        field = "";
      } else if (ch === "\r") {
        // ignore
      } else field += ch;
    }
  }
  if (field.length > 0 || cur.length > 0) {
    cur.push(field);
    rows.push(cur);
  }
  if (!rows.length) return { headers: [], rows: [] };
  const headers = rows[0].map((h) => h.trim().toLowerCase());
  const data = rows.slice(1).filter((r) => r.some((c) => (c || "").trim() !== ""));
  return { headers, rows: data.map((r) => Object.fromEntries(headers.map((h, i) => [h, (r[i] || "").trim()]))) };
}

function csvEscape(v) {
  if (v == null) return "";
  const s = String(v);
  if (/[",\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
  return s;
}

export function leadsToCsv(leads) {
  const headers = [
    "name",
    "email",
    "email_status",
    "email_score",
    "title",
    "company",
    "domain",
    "linkedin_url",
    "industry",
    "company_size",
    "tech_stack_cloud",
    "tech_stack_crm",
    "tech_stack_security",
    "tech_stack_infra",
    "products",
    "hiring_signals",
    "recent_news",
    "buying_committee",
    "pain_points",
    "playbook_timing",
    "playbook_opening",
    "playbook_value_prop",
    "playbook_case_study",
    "tags",
    "opportunity_score",
  ];
  const lines = [headers.join(",")];
  for (const l of leads) {
    const i = l.input || {};
    const e = l.enrichment || {};
    const c = e.contact || {};
    const row = [
      i.name,
      c.email || i.email,
      c.email_status || "",
      c.email_score ?? "",
      c.title || i.title,
      i.company,
      i.domain,
      c.linkedin_url || i.linkedin_url,
      e.company_overview?.industry,
      e.company_overview?.company_size,
      (e.tech_stack?.cloud || []).join("; "),
      (e.tech_stack?.crm || []).join("; "),
      (e.tech_stack?.security || []).join("; "),
      (e.tech_stack?.infrastructure || []).join("; "),
      (e.products || []).join("; "),
      (e.intent_signals?.hiring_signals || []).map((h) => `${h.role} (${h.posted})`).join("; "),
      (e.intent_signals?.recent_news || []).map((n) => n.headline).join("; "),
      (e.buying_committee || []).map((b) => b.role).join("; "),
      (e.pain_points || []).join("; "),
      e.engagement_playbook?.timing,
      e.engagement_playbook?.opening_line,
      e.engagement_playbook?.value_prop,
      e.engagement_playbook?.case_study_angle,
      (e.tags || []).join("; "),
      e.opportunity_score,
    ];
    lines.push(row.map(csvEscape).join(","));
  }
  return lines.join("\n");
}

export function downloadCsv(filename, csvText) {
  const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function buildLeadTemplateCsv() {
  const headers = ["name", "email", "title", "company", "domain", "linkedin_url"];
  const sample = [
    [
      "Jane Doe",
      "jane@acmecorp.com",
      "VP of IT",
      "Acme Corp",
      "acmecorp.com",
      "https://www.linkedin.com/in/janedoe/",
    ],
    [
      "John Smith",
      "john@globex.io",
      "CTO",
      "Globex",
      "globex.io",
      "",
    ],
  ];
  const lines = [headers.join(",")];
  for (const row of sample) lines.push(row.map(csvEscape).join(","));
  return lines.join("\n");
}
